import React from 'react';
import { IconLocation, IconUser } from 'design-system/icons';
import IconBoldQuestion from 'design-system/icons/IconBoldQuestion';
import { IconForbidden } from 'design-system/icons/IconForbidden';
import { IconJudge } from 'design-system/icons/IconJudge';
import { IconVote } from 'design-system/icons/IconVote';
import CreditReportLenderLogo from '../components/CreditReportLenderLogo';
const STATIC_META = {
    AddressLink: {
        topLabel: 'Address',
        renderIcon: () => <IconLocation alt gradientKey="yellow"/>,
    },
    AliasLink: {
        topLabel: 'Name',
        renderIcon: () => <IconUser gradientKey="darkPurple"/>,
    },
    AssociateLink: {
        topLabel: 'Connection',
        renderIcon: () => <IconUser alt gradientKey="orange"/>,
    },
    ElectoralRoll: {
        topLabel: 'Electoral roll',
        renderIcon: () => <IconVote alt gradientKey="apricot"/>,
    },
    ElectoralRollNoRecord: {
        topLabel: 'Electoral roll',
        renderIcon: () => <IconVote alt gradientKey="apricot"/>,
    },
    CCJ: {
        topLabel: 'Case number',
        renderIcon: () => <IconJudge alt gradientKey="darkPink"/>,
    },
    BankruptcyOrSequestration: {
        topLabel: 'Case reference',
        renderIcon: () => <IconForbidden gradientKey="peach"/>,
    },
    AdministrationOrder: {
        topLabel: 'Case reference',
        renderIcon: () => <IconForbidden gradientKey="peach"/>,
    },
    DebtReliefOrder: {
        topLabel: 'Case reference',
        renderIcon: () => <IconForbidden gradientKey="peach"/>,
    },
    IvaTrustDeedOrFastTrackVoluntaryArrangement: {
        topLabel: 'Case reference',
        renderIcon: () => <IconForbidden gradientKey="peach"/>,
    },
};
const FALLBACK = {
    topLabel: 'Item',
    icon: <IconBoldQuestion gradientKey="skyBlue"/>,
};
export function getDisputeMeta(disputeType, context) {
    if (disputeType === 'FinancialAccountInformation' ||
        disputeType === 'SearchHistory') {
        return {
            topLabel: disputeType === 'FinancialAccountInformation'
                ? 'Account'
                : 'Search reference',
            renderIcon: () => (<CreditReportLenderLogo iconUrl={context?.iconUrl} name={context?.lenderName} size="medium" inSettingsItem/>),
        };
    }
    const entry = STATIC_META[disputeType];
    if (!entry)
        return FALLBACK;
    return { topLabel: entry.topLabel, icon: entry.renderIcon() };
}
